import React, { useId } from 'react';

export default function ShelfIcon({ className, ...props }) {
    // Unique per instance: with a shared id, a hidden copy of the logo (e.g. the mobile header)
    // owns the gradient and every visible copy renders empty.
    const gradientId = `shelf-logo-gradient-${useId().replace(/:/g, '')}`;
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 85 85" {...props}>
            <path
                fill={`url(#${gradientId})`}
                d="M0 85V68h85v17H0zm63.75-33.056V0H85v51.944H63.75zm-63.75 0V0h21.25v51.944H0zm30.694 0V0h23.612v51.944H30.694z"
            ></path>
            <defs>
                <linearGradient id={gradientId} x1="42.5" x2="42.5" y1="0" y2="85" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#345573"></stop>
                    <stop offset="1" stopColor="#031728"></stop>
                </linearGradient>
            </defs>
        </svg>
    );
}
